export const setNextPrevIds = (ids, title) => {
    // console.log(title,ids);
    return ({
        type: "NEXT_PREV_SET",
        ids,
        title,
    });
}